/** Site-wide brand strings, navigation, and contact placeholders. */

export const BRAND = {
  name: 'Vuganawe',
  wordmark: 'Vuga Nawe',
  tagline: 'Practical Language Academy',
  shortPitch: 'Learn English for real life — not just exams.',
} as const;

/** Shown on course pages as "Your coach". Replace with the real coach's details. */
export const INSTRUCTOR = {
  name: 'The Vuganawe Coaching Team',
  title: 'Practical English coaches — Kigali',
  bio: 'Courses are written and taught by the Vuganawe coaching team: practical English trainers who teach real conversations for work, services, and daily life in Rwanda. Every course follows the same method as our live classes — short lessons, lots of speaking, and honest feedback.',
} as const;

export const CONTACT = {
  phone: '0788674885 / 0783902554',
  email: 'hello@vuganawe.com',
  whatsappUrl: 'https://wa.me/250788674885',
  location: 'Kigali, Rwanda',
} as const;

export interface NavLink {
  label: string;
  href: string;
}

export const NAV_LINKS: NavLink[] = [
  { label: 'Learn', href: '/learn' },
  { label: 'Corporate', href: '/corporate-training' },
  { label: 'Resources', href: '/resources' },
  { label: 'Blog', href: '/blog' },
  { label: 'About', href: '/about' },
  { label: 'Contact', href: '/contact' },
];

export const FOOTER_PROGRAM_LINKS: NavLink[] = [
  { label: 'All programs', href: '/programs' },
  { label: 'Speaking Confidence', href: '/speaking-confidence' },
  { label: 'Private coaching', href: '/private-coaching' },
  { label: 'Corporate training', href: '/corporate-training' },
  { label: 'Young learners', href: '/young-learners' },
  { label: 'Online learning', href: '/online-learning' },
];

export const FOOTER_COMPANY_LINKS: NavLink[] = [
  { label: 'About Vuganawe', href: '/about' },
  { label: 'Success stories', href: '/testimonials' },
  { label: 'Blog', href: '/blog' },
  { label: 'FAQ', href: '/faq' },
  { label: 'The learning app', href: '/learning-app' },
];

export const FOOTER_LEGAL_LINKS: NavLink[] = [
  { label: 'Terms of Service', href: '/terms' },
  { label: 'Privacy Policy', href: '/privacy' },
];

export const FOOTER_ACTION_LINKS: NavLink[] = [
  { label: 'Start learning', href: '/learn' },
  { label: 'Free learning resources', href: '/resources' },
  { label: 'Contact us', href: '/contact' },
];
